import { createRouter, createWebHistory } from 'vue-router'
import store from '@/_store';
import cookie from "@/_helpers/cookie";
import { hotSpotsList, stateMenuList } from '@/_helpers/hotSpotsActiveMenu';
import { styleGuide } from '@/_helpers/routes/styleguide';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/pages/home/Home.vue'),
    meta: {
      layout: 'restyle',
      title: 'Мобильные приложения для Android',
      breadcrumb: [
        {
          name: 'Главная',
        },
      ],
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/Auth/Login.vue'),
    meta: {
      title: 'Логин',
      layout: 'empty',
    },
  },
  {
    path: '/user/:id',
    name: 'user',
    component: () => import('@/pages/User/User'),
    meta: {
      title: 'Профиль пользователя',
      layout: 'restyle',
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Профиль пользователя',
        },
      ],
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/pages/Auth/ForgotPassword'),
    meta: {
      layout: 'empty',
      title: 'Забыли пароль?',
    },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/pages/Auth/ResetPassword'),
    meta: {
      layout: 'empty',
      title: 'Восстановление пароля',
    },
  },
  {
    path: '/roles',
    name: 'role_all',
    component: () => import('@/pages/Role/Roles'),
    meta: {
      layout: 'restyle',
      title: 'Роли',
      active: 1,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Роли',
        },
      ],
      section: 'admin',
      titleMenu: 'Роли',
    },
  },
  {
    path: '/organisations',
    name: 'organisations',
    component: () => import('@/pages/Organisations/Organisations'),
    meta: {
      layout: 'restyle',
      title: 'Организации',
      active: 1,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Организации',
        },
      ],
      section: 'admin',
      titleMenu: 'Организации',
    },
  },
  {
    path: '/users',
    name: 'user_all',
    component: () => import('@/pages/Reference/Users/Users'),
    meta: {
      layout: 'restyle',
      title: 'Пользователи',
      active: 1,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Пользователи',
        },
      ],
      section: 'admin',
      titleMenu: 'Пользователи',
    },
  },
  {
    path: '/users-mobile',
    name: 'mobile-user_all',
    component: () => import('@/pages/Reference/UsersMobile/UsersMobile'),
    meta: {
      layout: 'restyle-mobile',
      title: 'Пользователи',
      active: 1,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Пользователи',
        },
      ],
      section: 'admin',
    },
  },
  {
    path: '/inventory',
    name: 'inventory',
    component: () =>
      import('@/pages/Inventory_restyle/Inventory_map/Inventory_map'),
    meta: {
      layout: 'restyle',
      title: 'Инвентаризация',
      active: 2,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Инвентаризация',
        },
      ],
      section: 'inventory',
      titleMenu: 'Инвентаризация',
    },
  },
  {
    path: '/inventory/platform',
    name: 'inventory_platform',
    component: () =>
      import(
        '@/pages/Inventory_restyle/Inventory_platforms/Inventory_platforms'
      ),
    meta: {
      layout: 'restyle',
      title: 'Контейнерные площадки',
      active: 2,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Инвентаризация контейнерные площадки',
        },
      ],
      section: 'inventory',
      titleMenu: 'Контейнерные площадки',
    },
  },
  {
    path: '/inventory/platform/:id',
    name: 'inventory_platform_view',
    component: () =>
      import(
        '@/pages/Inventory_restyle/Inventory_platforms/Inventory_detail_platform/Inventory_detail_platform'
      ),
    meta: {
      layout: 'restyle',
      title: 'Контейнерная площадка',
      active: 2,
      teleport: true,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Контейнерная площадка',
        },
      ],
      section: 'inventory',
    },
  },
  {
    path: '/reference/container-type',
    name: 'container_type',
    component: () => import('@/pages/Reference/ContainerType'),
    meta: {
      layout: 'restyle',
      title: 'Типы контейнеров',
      active: 1,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Справочники',
        },
        {
          name: 'Типы контейнеров',
        },
      ],
      section: 'reference',
      titleMenu: 'Типы контейнеров',
    },
  },
  {
    path: '/reference/garbage-type',
    name: 'garbage_type',
    component: () => import('@/pages/Reference/garbage_types/WasteTypes'),
    meta: {
      layout: 'restyle',
      title: 'Типы отходов',
      active: 1,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Справочники',
        },
        {
          name: 'Типы отходов',
        },
      ],
      section: 'reference',
      titleMenu: 'Типы отходов',
    },
  },
  {
    path: '/reference/reasons-stopped-container',
    name: 'reasons_stopped_container',
    component: () =>
      import(
        '@/pages/Reference/reasons_stopped_container/ReasonsStoppedContainer'
      ),
    meta: {
      layout: 'restyle',
      title: 'Причины приостановки контейнеров',
      active: 1,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Справочники',
        },
        {
          name: 'Причины приостановки контейнеров',
        },
      ],
      section: 'reference',
      titleMenu: 'Причины приостановки контейнеров',
    },
  },
  {
    path: '/platform-type',
    name: 'platform_type',
    component: () => import('@/pages/Reference/PlatformType'),
    meta: {
      layout: 'restyle',
      title: 'Типы контейнерных площадок',
      active: 1,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Справочники',
        },
        {
          name: 'Типы контейнерных площадок',
        },
      ],
      section: 'reference',
      titleMenu: 'Типы контейнерных площадок',
    },
  },
  {
    path: '/failure-reason',
    name: 'failure_reason',
    component: () => import('@/pages/Reference/Failure/FailureReason'),
    meta: {
      layout: 'restyle',
      title: 'Причины невывозов',
      active: 1,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Справочники',
        },
        {
          name: 'Причины невывоза',
        },
      ],
      section: 'reference',
      titleMenu: 'Причины невывозов',
    },
  },
  {
    path: '/early-completion',
    name: 'early completion',
    component: () =>
      import('@/pages/Reference/EarlyCompletion/EarlyCompletion'),
    meta: {
      layout: 'restyle',
      title: 'Причины досрочного завершения рейса',
      active: 1,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Справочники',
        },
        {
          name: 'Причины досрочного завершения рейса',
        },
      ],
      section: 'reference',
      titleMenu: 'Причины досрочного завершения рейса',
    },
  },
  {
    path: '/breakdown-type',
    name: 'breakdown_type',
    component: () => import('@/pages/Reference/BreakDown/BreakdownType'),
    meta: {
      layout: 'restyle',
      title: 'Типы проблем',
      active: 1,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Справочники',
        },
        {
          name: 'Типы проблем',
        },
      ],
      section: 'reference',
      titleMenu: 'Типы проблем',
    },
  },
  {
    path: '/weight-cancel-reason',
    name: 'weight_cancel_reason',
    component: () =>
      import('@/pages/Reference/WeightCancelReason/WeightCancelReason'),
    meta: {
      layout: 'restyle',
      title: 'Причины отмены взвешиваний',
      active: 1,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Справочники',
        },
        {
          name: 'Причины отмены взвешиваний',
        },
      ],
      section: 'reference',
      titleMenu: 'Причины отмены взвешиваний',
    },
  },
  {
    path: '/carpark/vehicle',
    name: 'vehicle',
    component: () => import('@/pages/Carpark/Vehicles'),
    meta: {
      layout: 'restyle',
      title: 'Автомобили',
      active: 3,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Автопарк',
        },
        {
          name: 'Автомобили',
        },
      ],
      section: 'carpark',
      titleMenu: 'Автомобили',
    },
  },
  {
    path: '/carpark/vehicle_mobile',
    name: 'mobile_vehicle',
    component: () => import('@/pages/CarparkMobile/VehiclesMobile.vue'),
    meta: {
      layout: 'restyle-mobile',
      title: 'Автомобили',
      active: 3,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Автопарк',
        },
        {
          name: 'Автомобили',
        },
      ],
      section: 'carpark',
    },
  },
  {
    path: '/carpark/sensor/:id',
    name: 'sensorID',
    component: () => import('@/pages/Carpark/Sensor'),
    meta: {
      layout: 'restyle',
      title: 'Датчик заполненности',
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Автопарк',
        },
        {
          name: 'Датчик заполненности машины',
        },
      ],
      section: 'carpark',
    },
  },
  {
    path: '/carpark/statistic-beta/:vehicle_id',
    name: 'statistic_vehicle_beta',
    component: () => import('@/pages/Carpark/vehicle_statistic/statistic.vue'),
    meta: {
      layout: 'restyle',
      title: 'График заполненности',
      teleport: true,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Автопарк',
        },
        {
          name: 'График заполненности',
        },
      ],
      section: 'carpark',
    },
  },
  {
    path: '/carpark/statistic/:vehicle_id',
    name: 'statistic_vehicle',
    component: () =>
      import('@/pages/Carpark/vehicle_statistic/statisticOLDversion.vue'),
    meta: {
      layout: 'restyle',
      title: 'График заполненности',
      teleport: true,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Автопарк',
        },
        {
          name: 'График заполненности',
        },
      ],
      section: 'carpark',
    },
  },
  {
    path: '/fact/online-monitoring-photo',
    name: 'online_monitoring_photo',
    component: () =>
      import('@/pages/OnlineMonitoringPhoto/OnlineMonitoringPhoto'),
    meta: {
      layout: 'restyle',
      title: 'Фотографии',
      active: 3,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Фотографии',
        },
      ],
      section: 'fact',
      titleMenu: 'Фотографии',
    },
  },
  {
    path: '/fact/online-monitoring-photo_beta',
    name: 'online_monitoring_photo_beta',
    component: () =>
      import(
        '@/pages/OnlineMonitoringPhotoBeta/OnlineMonitoringPhotoBeta.vue'
      ),
    meta: {
      layout: 'restyle',
      title: 'Фотографии бета',
      active: 3,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Фотографии',
        },
      ],
      section: 'fact',
      titleMenu: 'Фотографии бета',
    },
  },
  {
    path: '/technical_department/sensors',
    name: 'vehicle_sensor',
    component: () => import('@/pages/technicalDepartment/VehicleSensor'),
    meta: {
      layout: 'restyle',
      title: `Устройства Gserver`,
      active: 9,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Технический отдел',
        },
        {
          name: `Устройства Gserver`,
        },
      ],
      section: 'technicalDepartment',
      titleMenu: `Устройства Gserver`,
    },
  },
  {
    path: '/technical_department/sensors/:id',
    name: 'sensor',
    component: () => import('@/pages/technicalDepartment/sensor'),
    meta: {
      layout: 'restyle',
      title: 'Gserver',
      active: 5,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Технический отдел',
        },
        {
          name: 'Gserver',
        },
      ],
      section: 'technicalDepartment',
    },
  },
  {
    path: '/technical_department/all_list_sensor_components',
    name: 'all_list_sensor_components',
    component: () =>
      import('@/pages/technicalDepartment/all_list_sensor_components/'),
    meta: {
      layout: 'restyle',
      title: 'Комплектация устройств',
      active: 9,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Технический отдел',
        },
        {
          name: 'Комплектация устройств',
        },
      ],
      section: 'technicalDepartment',
      titleMenu: 'Комплектация устройств',
    },
  },
  {
    path: '/technical_department/install_documents',
    name: 'install_documents',
    component: () =>
      import('@/pages/technicalDepartment/Install_documents/Install_documents'),
    meta: {
      layout: 'restyle',
      title: `Документы для установщиков`,
      active: 7,
      section: 'installer',
      titleMenu: 'Документы',
    },
  },
  {
    path: '/technical_department/install_documents/:id',
    name: 'detail_document',
    component: () =>
      import(
        '@/pages/technicalDepartment/Install_documents/Detail_document/Detail_document'
      ),
    meta: {
      layout: 'restyle',
      title: 'Детальная информация',
      active: 7,
      section: 'installer',
    },
  },
  {
    path: '/technical_department/install_documents/:id/paragraph/:paragraph_id',
    name: 'paragraph_document',
    component: () =>
      import(
        '@/pages/technicalDepartment/Install_documents/Detail_document/Paragraph_instruction/Paragraph_instruction'
      ),
    meta: {
      layout: 'restyle',
      title: `Параграф документа`,
      active: 5,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Технический отдел',
        },
        {
          name: `Детальная документа`,
        },
        {
          name: `Параграф документа`,
        },
      ],
      section: 'technicalDepartment',
    },
  },
  {
    path: '/technical_department/instruction_documents',
    name: 'instruction_documents',
    component: () =>
      import(
        '@/pages/technicalDepartment/Install_documents/Instruction_documents/Instruction_documents'
      ),
    meta: {
      layout: 'restyle',
      title: `Инструкции`,
      active: 7,
      section: 'installer',
      titleMenu: 'Инструкции',
    },
  },
  {
    path: '/technical_department/instruction_documents/create_instruction',
    name: 'create_instruction_install',
    component: () =>
      import(
        '@/pages/technicalDepartment/Install_documents/Instruction_documents/createInstruction'
      ),
    meta: {
      layout: 'restyle',
      title: `Создание инструкции`,
      active: 5,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Технический отдел',
        },
        {
          name: `Инструкции`,
        },
        {
          name: `Создание инструкции установки`,
        },
      ],
      section: 'technicalDepartment',
      titleMenu: 'Создание инструкции установки',
    },
  },
  {
    path: '/technical_department/instruction_documents/edit_instruction',
    name: 'edit_instruction_install',
    component: () =>
      import(
        '@/pages/technicalDepartment/Install_documents/Instruction_documents/editInstruction'
      ),
    meta: {
      layout: 'restyle',
      title: `Редактирование инструкции`,
      active: 5,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Технический отдел',
        },
        {
          name: `Инструкции`,
        },
        {
          name: `Редактирование инструкции установки`,
        },
      ],
      section: 'technicalDepartment',
      titleMenu: 'Редактирование инструкции установки',
    },
  },
  {
    path: '/technical_department/instruction_documents/:instruction_id',
    name: 'detail_instruction',
    component: () =>
      import(
        '@/pages/technicalDepartment/Install_documents/Instruction_documents/Detail_instruction/Detail_instruction'
      ),
    meta: {
      layout: 'restyle',
      title: `Детальная информация о инструкции`,
      active: 5,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Технический отдел',
        },
        {
          name: `Детальная информация о инструкции`,
        },
      ],
      section: 'technicalDepartment',
      titleMenu: 'Детальная информация о инструкции',
    },
  },
  {
    path: '/technical_department/fichas_update',
    name: 'fichas_update',
    component: () =>
      import('@/pages/technicalDepartment/Fichas_update/Fichas_update'),
    meta: {
      layout: 'restyle',
      title: `Фичи для добавления`,
      active: 7,
      section: 'installer',
      titleMenu: 'Фичи для добавления',
    },
  },
  {
    path: '/technical_department/task_installer',
    name: 'task_installer',
    component: () =>
      import('@/pages/technicalDepartment/Task_installer/Task_installer'),
    meta: {
      layout: 'restyle',
      title: 'Задачи установщика',
      active: 7,
      section: 'installer',
      titleMenu: 'Задачи',
    },
  },
  {
    path: '/technical_department/labels',
    name: 'labels',
    component: () => import('@/pages/technicalDepartment/labels/labels'),
    meta: {
      layout: 'restyle',
      title: `Метки`,
      active: 7,
      section: 'installer',
      titleMenu: 'Метки',
    },
  },
  {
    path: '/technical_department/command_gserver',
    name: 'command_gserver',
    component: () =>
      import('@/pages/technicalDepartment/Command_gserver/Command_gserver'),
    meta: {
      layout: 'restyle',
      title: `Команды Gserver`,
      active: 9,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Технический отдел',
        },
        {
          name: `Команды Gserver`,
        },
      ],
      section: 'technicalDepartment',
      titleMenu: 'Команды Gserver',
    },
  },
  {
    path: '/technical_department/list_logs',
    name: 'list_logs',
    component: () => import('@/pages/technicalDepartment/list_logs/list'),
    meta: {
      layout: 'restyle',
      title: `Список логов`,
      active: 1,
      section: 'technicalDepartment',
      titleMenu: 'Список логов',
    },
  },
  {
    path: '/technical_department/organisation_settings/contentOrganisationSettings',
    name: 'organisation_settings',
    component: () =>
      import(
        '@/pages/technicalDepartment/organisation_settings/contentOrganisationSettings'
      ),
    meta: {
      layout: 'restyle',
      title: `Настройки организации`,
      active: 1,
      section: 'technicalDepartment',
      titleMenu: 'Настройки организации',
    },
  },
  {
    path: '/logistic/CreatePolygon',
    name: 'createPolygon',
    component: () => import('@/pages/logistic/polygon/CreatePolygon'),
    meta: {
      layout: 'restyle',
      title: 'Создание полигона',
      active: 4,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Логистика',
        },
        {
          name: 'Создание полигона',
        },
      ],
      section: 'logistic',
    },
  },
  {
    path: '/logistic/EditPolygon/:id',
    name: 'EditPolygon',
    component: () => import('@/pages/logistic/polygon/EditPolygon'),
    meta: {
      layout: 'restyle',
      title: 'Редактирование полигона',
      active: 4,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Логистика',
        },
        {
          name: 'Редактирование полигона',
        },
      ],
      section: 'logistic',
    },
  },
  {
    path: '/logistic/polygon',
    name: 'polygon',
    component: () => import('@/pages/logistic/polygon/Polygon'),
    meta: {
      layout: 'restyle',
      title: 'Полигоны',
      active: 4,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Логистика',
        },
        {
          name: 'Полигоны',
        },
      ],
      section: 'logistic',
      titleMenu: 'Полигоны',
    },
  },
  {
    path: '/Integration',
    name: 'Integration',
    props: true,
    component: () =>
      import('@/pages/Integrations/Integration_rgSoft/Integration'),
    children: [
      {
        path: 'Integration_vehicles',
        name: 'Integration_vehicles',
        props: true,
        component: () =>
          import(
            '@/pages/Integrations/Integration_rgSoft/Integration_vehicles'
          ),
        meta: {
          layout: 'restyle',
          title: 'Интеграция c РГсофт',
          active: 5,
          breadcrumb: [
            {
              name: 'Главная',
              link: '/',
            },
            {
              name: 'Интеграция c РГсофт',
            },
          ],
          section: 'Integration',
        },
      },
      {
        path: 'Integration_fact_waybills',
        name: 'Integration_fact_waybills',
        props: true,
        component: () =>
          import(
            '@/pages/Integrations/Integration_rgSoft/Integration_fact_waybills'
          ),
        meta: {
          layout: 'restyle',
          title: 'Интеграция c РГсофт',
          active: 5,
          breadcrumb: [
            {
              name: 'Главная',
              link: '/',
            },
            {
              name: 'Интеграция c РГсофт',
            },
          ],
          section: 'Integration',
        },
      },
      {
        path: 'Integration_containers_type',
        name: 'Integration_containers_type',
        props: true,
        component: () =>
          import(
            '@/pages/Integrations/Integration_rgSoft/Integration_containers_type'
          ),
        meta: {
          layout: 'restyle',
          title: 'Интеграция c РГсофт',
          active: 5,
          breadcrumb: [
            {
              name: 'Главная',
              link: '/',
            },
            {
              name: 'Интеграция c РГсофт',
            },
          ],
          section: 'Integration',
        },
      },
    ],
    meta: {
      layout: 'restyle',
      title: 'Интеграция c РГсофт',
      active: 5,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Интеграция c РГсофт',
        },
      ],
      section: 'Integration',
      titleMenu: 'РГСОФТ',
    },
  },
  {
    path: '/Integrations',
    name: 'Integrations',
    component: () =>
      import(
        '@/pages/Integrations/IntegrationAvtospecbaza/IntegrationAvtospecbaza'
      ),
    meta: {
      layout: 'restyle',
      title: 'Интеграции',
      active: 5,
      section: 'Integration',
      titleMenu: 'Интеграции',
    },
  },
  {
    path: '/Integration_element_technology',
    name: 'Integration_element_technology',
    component: () =>
      import(
        '@/pages/Integrations/IntegrationElementTechnology/IntegrationElementTechnology'
      ),
    meta: {
      layout: 'restyle',
      title: 'Интеграция с ДУН',
      active: 5,
      section: 'Integration',
      titleMenu: 'Интеграция с ДУН',
    },
  },
  {
    path: '/manager-mobile-version',
    name: 'manager-mobile-version',
    component: () =>
      import('@/pages/ManagerMobileVersion/ManagerMobileVersion.vue'),
    meta: {
      layout: 'restyle',
      title: 'Управление версиями мобильных приложений',
      active: 5,
      section: 'Integration',
      titleMenu: 'Управление версиями мобильных приложений',
    },
  },
  {
    path: '/transfer_shift_task/:id',
    name: 'transfer_shift_task',
    redirect: (to) => {
      return { name: 'transfer_shift_task_map' };
    },
    component: () => import('@/pages/Transfer_shift_task/Transfer_shift_task'),
    meta: {
      title: 'Перенос КП из СЗ в СЗ',
      layout: 'restyle',
      teleport: true,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Перенос КП из СЗ в СЗ',
        },
      ],
      section: 'transfer',
    },
    children: [
      {
        path: 'map',
        name: 'transfer_shift_task_map',
        component: () =>
          import(
            '@/pages/Transfer_shift_task/Transfer_shift_task_map/Transfer_shift_task_map_vue3'
          ),
        meta: {
          title: 'Перенос КП из СЗ в СЗ',
          layout: 'restyle',
          teleport: true,
          breadcrumb: [
            {
              name: 'Главная',
              link: '/',
            },
            {
              name: 'Перенос КП из СЗ в СЗ',
            },
            {
              name: 'Карта',
            },
          ],
          section: 'transfer',
        },
      },
      {
        path: 'table',
        name: 'transfer_shift_task_table',
        component: () =>
          import(
            '@/pages/Transfer_shift_task/Transfer_shift_task_table/Transfer_shift_task_table'
          ),
        meta: {
          title: 'Перенос КП из СЗ в СЗ',
          layout: 'restyle',
          teleport: true,
          breadcrumb: [
            {
              name: 'Главная',
              link: '/',
            },
            {
              name: 'Перенос КП из СЗ в СЗ',
            },
            {
              name: 'Список',
            },
          ],
          section: 'transfer',
        },
      },
    ],
  },
  {
    path: '/list_sensor_containers',
    name: 'list_sensor_containers',
    component: () =>
      import('@/pages/List_sensor_containers/List_sensor_containers'),
    meta: {
      title: 'Список контейнеров с датчиками заполненности',
      active: 1,
      layout: 'restyle',
      teleport: false,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Перенос КП из СЗ в СЗ',
        },
      ],
      section: 'list_sensor_containers',
      titleMenu: 'Список контейнеров с датчиками заполненности',
    },
  },
  {
    path: '/list_sensor_containers/statistic_container/:id',
    name: 'statistic_container',
    component: () =>
      import(
        '@/pages/List_sensor_containers/Statistic_container/Statistic_container'
      ),
    meta: {
      title: 'Статистика датчика в контейнере',
      active: 1,
      layout: 'restyle',
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Перенос КП из СЗ в СЗ',
        },
        {
          name: 'Статистика датчика в контейнере',
        },
      ],
      section: 'statistic_container',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/pages/error/PageNotFound'),
    meta: {
      layout: 'restyle',
      title: 'Мобильные приложения для Android',
      breadcrumb: [
        {
          name: 'Главная',
        },
      ],
    },
  },
  {
    path: '/demo-gserver',
    name: 'demo_gserver',
    component: () => import('@/pages/demo/gserver/gserver.vue'),
    meta: {
      title: 'Демо',
      layout: 'empty',
    },
  },
  {
    path: '/boss-app',
    name: 'boss_app_instruction',
    component: () =>
      import('@/pages/Boss_app_instruction/Boss_app_instruction'),
    meta: {
      title: 'Как установить',
      layout: 'empty',
    },
  },
  {
    path: '/test_boss',
    name: 'birthday_boss',
    component: () => import('@/pages/birthday_boss/birthday'),
    meta: {
      title: 'Серьёзный опрос',
      layout: 'empty',
    },
  },
  {
    path: '/online-list',
    name: 'online_list',
    component: () => import('@/pages/OnlineList/OnlineList.vue'),
    meta: {
      title: 'Онлайн список',
      layout: 'restyle',
      teleport: true,
      noPadding: true,
      titleMenu: 'Онлайн список',
    },
  },
  {
    path: '/reference/reasons-for-the-application',
    name: 'reasons_for_the_application',
    component: () =>
      import(
        '@/pages/Reference/reasonsForTheApplication/ReasonsForTheApplication'
      ),
    meta: {
      layout: 'restyle',
      title: 'Причины заявки',
      active: 1,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Справочники',
        },
        {
          name: 'Причины заявки',
        },
      ],
      section: 'reference',
      titleMenu: 'Причины заявки',
    },
  },
  {
    path: '/remove-account',
    name: 'remove-account',
    component: () => import('@/pages/remove_account/RemoveAccountPage'),
    meta: {
      layout: 'empty',
      title: 'Удаление аккаунта',
    },
  },
  {
    path: '/confirm/:hash',
    name: 'remove-account-confirm',
    component: () => import('@/pages/remove_account/RemoveAccountPage'),
    meta: {
      layout: 'empty',
      title: 'Удаление аккаунта',
    },
  },
  {
    path: '/navigation_systems',
    name: 'navigation_systems',
    component: () =>
      import('@/pages/Reference/navigation_systems/NavigationSystems.vue'),
    meta: {
      layout: 'restyle',
      title: 'Навигация',
      active: 1,
      section: 'reference',
      titleMenu: 'Навигация',
    },
  },
  {
    path: '/divisions_organisation',
    name: 'divisions_organisation',
    component: () =>
      import(
        '@/pages/Reference/DivisionsOrganinsation/DivisionsOrganinsation.vue'
      ),
    meta: {
      layout: 'restyle',
      title: 'Подразделения',
      active: 1,
      breadcrumb: [],
      section: 'reference',
      titleMenu: 'Подразделения',
    },
  },
  {
    path: '/reason_for_transferring_kp',
    name: 'reason_for_transferring_kp',
    component: () =>
      import(
        '@/pages/Reference/reasonForTransferringKp/reasonForTransferringKp.vue'
      ),
    meta: {
      layout: 'restyle',
      title: '  Причины переноса КП',
      active: 1,
      breadcrumb: [],
      section: 'reference',
      titleMenu: '  Причины переноса КП',
    },
  },
  {
    path: '/fact/monitoring-vehicle',
    name: 'monitoring_vehicle',
    component: () => import('@/pages/MonitoringVehicle/MonitoringVehicle'),
    meta: {
      layout: 'restyle',
      title: 'Мониторинг автомобилей',
      active: 3,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Мониторинг автомобилей',
        },
      ],
      section: 'fact',
      titleMenu: 'Мониторинг автомобилей',
    },
  },
  {
    path: '/technical_department/hot_spots',
    name: 'hot_spots',
    component: () => import('@/pages/technicalDepartment/hotSpots/hotSpot'),
    meta: {
      layout: 'restyle',
      title: `Редактирование хотспотов`,
    },
  },
  {
    path: '/fact/rework-online-monitoring',
    name: 'rework_online_monitoring',
    component: () =>
      import('@/pages/ReworkOnlineMonitoring/ReworkOnlineMonitoring'),
    meta: {
      layout: 'restyle',
      title: 'Онлайн-мониторинг',
      active: 3,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Онлайн-мониторинг',
        },
      ],
      section: 'fact',
      teleport: true,
      noPadding: true,
    },
  },
  {
    path: '/fact/online-monitoring/mobile',
    name: 'online-monitoring-mobile',
    component: () =>
      import(
        '@/pages/ReworkOnlineMonitoring/mobile/OnlineMonitoringMobile.vue'
      ),
    meta: {
      layout: 'restyle-mobile',
      title: 'Онлайн мониторинг',
    },
  },
  {
    path: '/fact/online-monitoring/mobile/events',
    name: 'online-monitoring-mobile-events',
    component: () =>
      import(
        '@/pages/ReworkOnlineMonitoring/mobile/events/OnlineMonitoringEvents.vue'
      ),
    meta: {
      layout: 'restyle-mobile',
      title: 'События',
      titleHeader: '',
    },
  },
  {
    path: '/fact/online-monitoring/mobile/events/failure-act',
    name: 'online-monitoring-mobile-failure-act',
    component: () =>
      import(
        '@/pages/ReworkOnlineMonitoring/mobile/events/failure_act/FailureAct.vue'
      ),
    meta: {
      layout: 'restyle-mobile',
      title: 'Акт по невывозам',
      titleHeader: '',
    },
  },
  {
    path: '/report-delay',
    name: 'report_delay',
    component: () => import('@/pages/Report_delay/Report_delay.vue'),
    meta: {
      layout: 'restyle',
      title: 'Отчёты',
      active: 6,
      breadcrumb: [],
      section: 'report-work-drivers',
      titleMenu: 'Отчёт по опозданиям',
    },
  },
  {
    path: '/reference/localities-area',
    name: 'localities_area',
    component: () =>
      import('@/pages/Reference/LocalitiesArea/LocalitiesArea.vue'),
    meta: {
      layout: 'restyle',
      title: 'Населенные пункты',
      active: 1,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Справочники',
        },
        {
          name: 'Населенные пункты',
        },
      ],
      section: 'reference',
      titleMenu: 'Населенные пункты',
    },
  },
  {
    path: '/reference/municipal-association',
    name: 'municipal_association',
    component: () =>
      import('@/pages/Reference/MunicipalAssociation/MunicipalAssociation.vue'),
    meta: {
      layout: 'restyle',
      title: 'Муниципальные образования',
      active: 1,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Справочники',
        },
        {
          name: 'Муниципальные образования',
        },
      ],
      section: 'reference',
      titleMenu: 'Муниципальные образования',
    },
  },
  {
    path: '/reference/sub-category',
    name: 'sub_category',
    component: () => import('@/pages/Reference/SubCategory/SubCategory.vue'),
    meta: {
      layout: 'restyle',
      title: 'Подкатегории',
      active: 1,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Справочники',
        },
        {
          name: 'Подкатегории',
        },
      ],
      section: 'reference',
      titleMenu: 'Подкатегории',
    },
  },
  {
    path: '/reference/incpectors-district',
    name: 'incpectors_district',
    component: () =>
      import('@/pages/Reference/IncpectorsDistrict/IncpectorsDistrict.vue'),
    meta: {
      layout: 'restyle',
      title: 'Инспекторы',
      active: 1,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Справочники',
        },
        {
          name: 'Инспекторы',
        },
      ],
      section: 'reference',
      titleMenu: 'Инспекторы',
    },
  },
  {
    path: '/inventory/inspector-task',
    name: 'inspector_task',
    component: () => import('@/pages/InspectorTask/InspectorTask.vue'),
    meta: {
      title: 'Наряд задание',
      active: 2,
      layout: 'restyle',
      teleport: true,
      noPadding: true,
      titleMenu: 'Наряд задание',
      section: 'inventory',
    },
  },
  {
    path: '/inventory/inspectors',
    name: 'inventory_inspectors',
    component: () =>
      import('@/pages/Inventory_inspectors/Inventory_inspectors'),
    meta: {
      layout: 'restyle',
      title: 'Инспекция',
      active: 2,
      teleport: true,
      noPadding: true,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Справочники',
        },
        {
          name: 'Инспекция',
        },
      ],
      section: 'inventory',
      titleMenu: 'Инспекция',
    },
  },
  {
    path: '/inventory/monitoring-value',
    name: 'inventory_monitoring_value',
    component: () =>
      import('@/pages/Inventory_monitoring_value/Inventory_monitoring_value'),
    meta: {
      layout: 'restyle',
      title: 'Инспекция',
      active: 2,
      teleport: true,
      noPadding: true,
      section: 'inventory',
      titleMenu: 'Инспекция',
    },
  },
  {
    path: '/inventory/inventory-polygons',
    name: 'inventory_polygons',
    component: () => import('@/pages/Inventory_polygons/InventoryPolygons.vue'),
    meta: {
      layout: 'restyle',
      title: 'Инспекция',
      active: 2,
      teleport: true,
      noPadding: true,
      section: 'inventory',
      titleMenu: 'Инспекция',
    },
  },
  {
    path: '/notifications/recipients',
    name: 'recipients',
    component: () => import('@/pages/Notifications/recipients'),
    meta: {
      layout: 'restyle',
      title: `Адресаты`,
      active: 8,
      section: 'recipients',
      titleMenu: 'Адресаты',
    },
  },
  {
    path: '/notifications/templates',
    name: 'notification-templates',
    component: () => import('@/pages/Notification_templates/templates'),
    meta: {
      layout: 'restyle',
      title: `Шаблоны уведомлений`,
      active: 8,
      section: 'recipients',
      titleMenu: 'Шаблоны уведомлений',
    },
  },
  {
    path: '/notifications/notifications',
    name: 'notifications',
    component: () =>
      import('@/pages/Notifications/Notifications/NotificationsPage.vue'),
    meta: {
      title: 'Уведомления',
      active: 8,
      layout: 'restyle',
      teleport: true,
      noPadding: true,
      titleMenu: 'Уведомления',
      section: 'notifications',
    },
  },
  {
    path: '/reference/employee',
    name: 'employee',
    component: () => import('@/pages/Reference/Employee/employee'),
    meta: {
      layout: 'restyle',
      title: 'Сотрудники',
      active: 1,
      section: 'reference',
      titleMenu: 'Сотрудники',
    },
  },
  {
    path: '/contract-block-services',
    name: 'contract-block-services',
    component: () => import('@/pages/contractBlock/servicesPage.vue'),
    meta: {
      title: 'Список услуг',
      active: 10,
      layout: 'restyle',
      noPadding: true,
      titleMenu: 'Список услуг',
      section: 'contract-block',
    },
  },
  {
    path: '/contract-block-tariffs',
    name: 'contract-block-tariffs',
    component: () => import('@/pages/contractBlock/tariffsPage.vue'),
    meta: {
      layout: 'restyle',
      section: 'contract-block',
      title: 'Перечень изменений тарифа для услуги',
    },
  },
  {
    path: '/contract-block-list-counterparties',
    name: 'contract-block-list-counterparties',
    component: () => import('@/pages/contractBlock/counterpartiesPage.vue'),
    meta: {
      title: 'Список контрагентов-ЮЛ/ИП',
      active: 10,
      layout: 'restyle',
      titleMenu: 'Список контрагентов-ЮЛ/ИП',
      section: 'contract-block-list-counterparties',
    },
  },
  {
    path: '/contract-block-list-contracts',
    name: 'contract-block-list-contracts',
    component: () => import('@/pages/contractBlock/contractsPage.vue'),
    meta: {
      title: 'Список договоров',
      active: 10,
      layout: 'restyle',
      titleMenu: 'Список договоров',
      section: 'contract-block-list-contracts',
    },
  },
  {
    path: '/contract-block/contract/edit/:contractId',
    name: 'contractEdit',
    component: () => import('@/pages/contractBlock/ContractCreateEditPage.vue'),
    meta: {
      title: 'Договор',
      active: 10,
      layout: 'restyle',
    },
  },
  {
    path: '/contract-block/contract/create/:contragentId',
    name: 'contractCreate',
    component: () => import('@/pages/contractBlock/ContractCreateEditPage.vue'),
    meta: {
      title: 'Договор',
      active: 10,
      layout: 'restyle',
    },
  },
  {
    path: '/contract-block-waste-generator-categories',
    name: 'contract-block-waste-generator-categories',
    component: () =>
      import('@/pages/contractBlock/WasteGeneratorCategoriesPage.vue'),
    meta: {
      title: 'Категории отходообразователей',
      active: 10,
      layout: 'restyle',
      titleMenu: 'Категории отходообразователей',
      section: 'contract-block-waste-generator-categories',
    },
  },
  {
    path: '/contract-block/contract/position/create/:contractId/:contractAmendmentId',
    name: 'createPositionContract',
    component: () =>
      import('@/pages/CreatePositionContract/CreateEditPositionContract'),
    meta: {
      layout: 'restyle',
      title: 'Добавление позиции в договор',
      active: 1,
      section: 'reference',
      titleMenu: 'Добавление позиции в договор',
    },
  },
  {
    path: '/contract-block/contract/position/edit/:contractPositionId',
    name: 'editPositionContract',
    component: () =>
      import('@/pages/CreatePositionContract/CreateEditPositionContract'),
    meta: {
      layout: 'restyle',
      title: 'Добавление позиции в договор',
      active: 1,
      section: 'reference',
      titleMenu: 'Добавление позиции в договор',
    },
  },
  {
    path: '/contract-block/contract/position/view/:contractPositionId',
    name: 'viewPositionContract',
    component: () =>
      import('@/pages/CreatePositionContract/viewPositionContract'),
    meta: {
      layout: 'restyle',
      title: 'Просмотр позиции договора',
      active: 1,
      section: 'reference',
      titleMenu: 'Просмотр позиции договора',
    },
  },
  {
    path: '/contract-block-templates',
    name: 'contract-block-templates',
    component: () => import('@/pages/contractBlock/contractTemplates.vue'),
    meta: {
      title: 'Шаблоны договоров',
      active: 10,
      layout: 'restyle',
      titleMenu: 'Шаблоны договоров',
      section: 'contract-block-templates',
    },
  },
  {
    path: '/contract-block-list-objects',
    name: 'contract-block-list-objects',
    component: () => import('@/pages/contractBlock/listObjects.vue'),
    meta: {
      title: 'Список объектов',
      active: 10,
      layout: 'restyle',
      titleMenu: 'Список объектов',
      section: 'contract-block',
    },
  },
  {
    path: '/additional-agreement-list/:contractId',
    name: 'additional-agreement-list',
    component: () => import('@/pages/additionalAgreement/list/list.vue'),
    meta: {
      title: 'Дополнительные соглашения',
      active: 10,
      layout: 'restyle',
      titleMenu: 'Дополнительные соглашения',
      section: 'contract-block',
    },
  },
  {
    path: '/contract-block/contract/amendment/:contractAmendmentId',
    name: 'createEditContractAmendment',
    component: () => import('@/pages/additionalAgreement/createEdit.vue'),
    meta: {
      title: 'Создание и редактирование дополнительного соглашения',
      active: 10,
      layout: 'restyle',
      titleMenu: 'Создание и редактирование дополнительного соглашения',
      section: 'contract-block',
    },
  },
  {
    path: '/reference/districts',
    name: 'districts',
    component: () => import('@/pages/Reference/Districts/Districts.vue'),
    meta: {
      layout: 'restyle',
      title: 'Районы',
      active: 1,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Справочники',
        },
        {
          name: 'Районы',
        },
      ],
      section: 'reference',
      titleMenu: 'Районы',
    },
  },
  {
    path: '/contract-block/object/detail/:objectId',
    name: 'objectDetail',
    component: () =>
      import('@/pages/contractBlockDetail/ObjectDetail.vue'),
    meta: {
      title: 'Информация об объекте',
      active: 10,
      layout: 'restyle',
      titleMenu: 'Информация об объекте',
      section: 'contract-block',
    },
  },
  {
    path: '/reference/talon-contractors',
    name: 'talon-contractors',
    component: () => import('@/pages/Counterparties/Counterparties.vue'),
    meta: {
      layout: 'restyle',
      title: 'Контрагенты',
      active: 1,
      breadcrumb: [],
      section: 'reference',
      titleMenu: 'Контрагенты',
    },
  },
  {
    path: '/reference/event-journal',
    name: 'talon-event-log',
    component: () => import('@/pages/EventJournal/EventJournal.vue'),
    meta: {
      layout: 'restyle',
      title: 'Журнал событий',
      active: 1,
      breadcrumb: [],
      section: 'reference',
      titleMenu: 'Журнал событий',
    },
  },
  {
    path: '/reference/roles-access',
    name: 'talon-roles-access',
    component: () => import('@/pages/RolesAccess/RolesAccess.vue'),
    meta: {
      layout: 'restyle',
      title: 'Роли и доступы',
      active: 1,
      breadcrumb: [],
      section: 'reference',
      titleMenu: 'Роли и доступы',
    },
  },
  {
    path: '/reference/reference-notifications/notifications-list',
    name: 'reference-notifications',
    component: () =>
      import(
        '@/pages/Reference/Notifications/NotificationsTab/NotificationsPage.vue'
      ),
    meta: {
      layout: 'restyle',
      title: 'Уведомления',
      active: 1,
      breadcrumb: [],
      section: 'reference',
      titleMenu: 'Уведомления',
    },
  },
  {
    path: '/reference/talon-integration-settings',
    name: 'talon-integration-settings',
    component: () =>
      import('@/pages/IntegrationSettings/IntegrationSettings.vue'),
    meta: {
      layout: 'restyle',
      title: 'Настройки интеграции',
      active: 1,
      breadcrumb: [],
      section: 'reference',
      titleMenu: 'Настройки интеграции',
    },
  },
  {
    path: '/reference/talon-journal',
    name: 'talon-ticket-log',
    component: () => import('@/pages/TalonJournal/TalonJournal.vue'),
    meta: {
      layout: 'restyle',
      title: 'Журнал талонов',
      active: 12,
      breadcrumb: [],
      section: 'reference',
      titleMenu: 'Журнал талонов',
    },
  },
  {
    path: '/reference/weighing-journal',
    name: 'talon-weighing-log',
    component: () => import('@/pages/WeighingJournal/WeighingJournal.vue'),
    meta: {
      layout: 'restyle',
      title: 'Журнал взвешиваний',
      active: 12,
      breadcrumb: [],
      section: 'reference',
      titleMenu: 'Журнал взвешиваний',
    },
  },
  {
    path: '/reference/reports-by-periods',
    name: 'talon-period-reports',
    component: () => import('@/pages/ReportsByPeriods/ReportsByPeriods.vue'),
    meta: {
      layout: 'restyle',
      title: 'Отчеты по периодам',
      active: 12,
      breadcrumb: [],
      section: 'reference',
      titleMenu: 'Отчеты по периодам',
    },
  },
  {
    path: '/reference/reconciliation-with-counterparties',
    name: 'talon-contractor-reconciliation',
    component: () =>
      import(
        '@/pages/ReconciliationWithCounterparties/ReconciliationWithCounterparties.vue'
      ),
    meta: {
      layout: 'restyle',
      title: 'Сверка с контрагентами',
      active: 12,
      breadcrumb: [],
      section: 'reference',
      titleMenu: 'Сверка с контрагентами',
    },
  },
  {
    path: '/reference/export-to-1c',
    name: 'talon-export-1c',
    component: () => import('@/pages/ExportTo1C/ExportTo1C.vue'),
    meta: {
      layout: 'restyle',
      title: 'Экспорт в 1С',
      active: 12,
      breadcrumb: [],
      section: 'reference',
      titleMenu: 'Экспорт в 1С',
    },
  },
  styleGuide,
  {
    path: '/talons/contract-journal',
    name: 'contract-journal-ecoprom',
    component: () =>
      import(
        '@/pages/Talons/ContractJournalEcoProm/ContractJournalEcoProm.vue'
      ),
    meta: {
      layout: 'restyle',
      title: 'Журнал договоров',
      active: 12,
      breadcrumb: [],
      section: 'talons',
      titleMenu: 'Журнал договоров',
    },
  },
  {
    path: '/reference/reference-notifications/registration-journal',
    name: 'registration-journal',
    component: () =>
      import(
        '@/pages/Reference/Notifications/registrationJournal/registrationJournal.vue'
      ),
    meta: {
      layout: 'restyle',
      title: 'Журнал регистрации',
      active: 1,
      breadcrumb: [],
      section: 'reference',
      titleMenu: 'Журнал регистрации',
    },
  },
  {
    path: '/fact/fgis-logs',
    name: 'fgis-logs',
    component: () => import('@/pages/technicalDepartment/fgisLogs/fgisLogs'),
    meta: {
      layout: 'restyle',
      active: 3,
      title: `Логи отправки данных во ФГИС`,
      titleMenu: 'Логи отправки данных во ФГИС',
    },
  },
  {
    path: '/fact/link-to-fgis',
    name: 'link_to_fgis',
    component: () => import('@/pages/LinkToFgis/LinkToFgis'),
    meta: {
      layout: 'restyle',
      title: 'Привязка КП к ФГИС',
      active: 3,
      breadcrumb: [
        {
          name: 'Главная',
          link: '/',
        },
        {
          name: 'Привязка КП к ФГИС',
        },
      ],
      section: 'fact',
      titleMenu: 'Привязка КП к ФГИС',
    },
  },
];

let hotspotRoutes = routes.filter((item) => {
  return hotSpotsList.indexOf(item.name) > -1;
}).map(item => {
  return {
    routeName: item.name,
    titleMenu: item.meta.titleMenu,
    value: item.meta.titleMenu,
    label: item.meta.titleMenu,
  };
});

hotspotRoutes = [...hotspotRoutes, ...stateMenuList];

store.commit('hotspots/setHotSpotRoutes', hotspotRoutes);

export const router = createRouter({
  history: createWebHistory(),
  routes,
}) 

// редирект на авторизацию если пользователь не залогинен
router.beforeEach((to, from, next) => {
  const publicPages = ['login', 'forgot-password', 'reset-password', 'boss_app_instruction', 'birthday_boss', 'remove-account', 'remove-account-confirm']; // массив разрешенных внешних страниц
	const authRequired = !publicPages.includes(to.name);
  if (cookie.getCookie('auth_token')) {
    cookie.updateCookie();
    store.commit('auth/authSuccess');
    store.commit('auth/auth', true);
    store.dispatch('auth/send', false);

    if (!authRequired) {
      return next();
    }
  } else {
      if (authRequired) {
      store.dispatch("auth/logout");
      return next('/login?redirect=' + from.fullPath);
    }
  }
	const loggedIn = localStorage.getItem('auth_token');
  
	if (authRequired && !loggedIn) {
		if (!publicPages.includes(from.name)) {
			return next('/login?redirect=' + from.fullPath);
    }
		else {
			return next('/login');
    }
	}
  //не даем зайти на страницу другого пользователя через url
  const userId = store.getters['user/user'].id;
  if (to.name === 'user' && to.params.id != userId && userId) {
    return next({ name: 'user', params: { id: userId } });
  }
	next();
});
